import styled from 'styled-components';

import { basicCaptionSmallTextStyle, Text } from '@dreryk/react-components';

export const StyledAdvancePaymentRefundAmountConditionText = styled(Text)`
   ${basicCaptionSmallTextStyle}
`;

StyledAdvancePaymentRefundAmountConditionText.displayName = 'StyledAdvancePaymentRefundAmountConditionText';
